import { Link } from "react-router-dom";
import { Shield, Heart } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-muted/30 border-t border-border">
      <div className="container px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center">
                <Shield className="w-5 h-5 text-primary" />
              </div>
              <span className="font-serif text-xl font-semibold text-foreground">
                SoulSafe
              </span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-sm mb-4">
              A sanctuary for survivors of spiritual abuse. Trauma-informed, 
              biblically grounded support for your healing journey.
            </p>
            <blockquote className="text-sm italic text-foreground/60 border-l-2 border-primary/30 pl-4">
              "He heals the brokenhearted and binds up their wounds."
              <cite className="block text-xs mt-1 not-italic">— Psalm 147:3</cite>
            </blockquote>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/courses" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Healing Courses
                </Link>
              </li>
              <li>
                <Link to="/journal" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Private Journal
                </Link>
              </li>
              <li>
                <Link to="/community" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Community
                </Link>
              </li>
              <li>
                <Link to="/crisis" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Crisis Support
                </Link>
              </li>
              <li>
                <Link to="/library" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Library
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link to="/verify-certificate" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Verify Certificate
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} SoulSafe. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Made with <Heart className="w-4 h-4 text-destructive" /> for healing
          </p>
        </div>
      </div>

      {/* Important disclaimer */}
      <div className="bg-muted/50 border-t border-border">
        <div className="container px-6 py-4">
          <p className="text-xs text-center text-muted-foreground">
            <strong>Important:</strong> SoulSafe provides educational and spiritual support 
            and is not a substitute for professional therapy or medical care. 
            If you are in crisis, please contact emergency services or call 988.
          </p>
        </div>
      </div>
    </footer>
  );
}